import { ErrorCode } from "./response";
import ERROR_CODE_MESSAGE from '@/i18n/message';

export enum PageType {
    ORGANIZATION = 'Organization',
    DEPARTMENT = 'Department',
    CATEGORY = 'Category',
    MATERIAL = 'Material',
    USER = 'User',
    ALERT = 'Alarm',
    INVENTORY = 'Inventory',
    PAYMENT = 'Payment',
    PERSONAL_SETTING = 'PersonalSetting',
    JANCODE = 'Jancode',
    HISTORY = 'History',
}

export function getErrorMessage(pageType: PageType, code?: ErrorCode): string {
    const messages = getErrorMessageRange(pageType);

    switch (code) {
        // CODE.MESSAGE　一対一
        case ErrorCode.OK:
            return ERROR_CODE_MESSAGE.COMMON.OK;
        case ErrorCode.AUTH_INVALID:
            return ERROR_CODE_MESSAGE.COMMON.AUTH_INVALID;
        case ErrorCode.IMPORT_CSV_FAILED:
            return ERROR_CODE_MESSAGE.COMMON.IMPORT_CSV_FAILED;
        case ErrorCode.EXPORT_CSV_FAILED:
            return ERROR_CODE_MESSAGE.COMMON.EXPORT_CSV_FAILED;
        case ErrorCode.PASSWORD_INCORRECT:
            return ERROR_CODE_MESSAGE.PERSONAL_SETTING.PASSWORD_INCORRECT;
        case ErrorCode.CHANGE_PASSWORD_FAILED:
            return ERROR_CODE_MESSAGE.PERSONAL_SETTING.CHANGE_PASSWORD_FAILED;
        case ErrorCode.MATERIAL_AND_GROUP_IMFORMATION_NOT_MATCH:
            return ERROR_CODE_MESSAGE.INVENTORY.MATERIAL_AND_GROUP_IMFORMATION_NOT_MATCH;        
        case ErrorCode.DEPARTMENT_HEAD_EXIST:
            return ERROR_CODE_MESSAGE.COMMON.DEPARTMENT_HEAD_EXIST;
        case ErrorCode.DELETE_FAILED_INVENTORY_EXISTS:
            return ERROR_CODE_MESSAGE.COMMON.DELETE_FAILED_INVENTORY_EXISTS;

        //　共通部分　MESSAGE　一対多
        case ErrorCode.GET_LIST_FAILED:
            return messages.GET_LIST_FAILED;
        case ErrorCode.GET_DETAIL_FAILED:
            return messages.GET_DETAIL_FAILED;
        case ErrorCode.NOT_FOUND:
            return messages.NOT_FOUND;
        case ErrorCode.ALREADY_EXIST:
            return messages.ALREADY_EXIST;
        case ErrorCode.CREATE_FAILED:
            return messages.CREATE_FAILED;
        case ErrorCode.UPDATE_FAILED:
            return messages.UPDATE_FAILED;
        case ErrorCode.DELETE_FAILED:
            return messages.DELETE_FAILED;

        default:
            return ERROR_CODE_MESSAGE.COMMON.FAILED;
    }
}

export function getErrorMessageRange(pageType: PageType) {

    switch (pageType) {
        case PageType.ORGANIZATION:
            return ERROR_CODE_MESSAGE.ORGANIZATION;
        case PageType.DEPARTMENT:
            return ERROR_CODE_MESSAGE.DEPARTMENT;
        case PageType.CATEGORY:
            return ERROR_CODE_MESSAGE.CATEGORY;
        case PageType.MATERIAL:
            return ERROR_CODE_MESSAGE.MATERIAL;
        case PageType.USER:
            return ERROR_CODE_MESSAGE.USER;
        case PageType.ALERT:
            return ERROR_CODE_MESSAGE.ALERT;
        case PageType.INVENTORY:
            return ERROR_CODE_MESSAGE.INVENTORY;
        case PageType.PAYMENT:
            return ERROR_CODE_MESSAGE.PAYMENT;
        case PageType.PERSONAL_SETTING:
            return ERROR_CODE_MESSAGE.PERSONAL_SETTING;
        case PageType.JANCODE:
            return ERROR_CODE_MESSAGE.JANCODE;
        case PageType.HISTORY:
            return ERROR_CODE_MESSAGE.HISTORY;
    }
}